/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ERP Browser BFF Auth API
 * Browser-facing authentication and session contract derived from the authoritative
 * backend gateway contract. Login and logout are top-level browser-navigation endpoints,
 * not ordinary fetch APIs.
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * Returns 200 for anonymous and authenticated sessions. Never redirects to login.
 * @summary Get current browser session state
 */

export const GetBffSessionResponse = zod.union([
  zod.object({
    authenticated: zod.literal(false),
    user: zod.null(),
  }),
  zod.object({
    authenticated: zod.literal(true),
    user: zod.object({
      id: zod
        .string()
        .min(1)
        .describe("Application identity mapped only from validated erp_user_id."),
      displayName: zod.string().min(1).describe("Presentation-only user label."),
      email: zod.email().optional().describe("Optional email. Omitted when unavailable."),
    }),
  }),
]);

/**
 * Fetch after confirming an authenticated session through `/bff/session`.
 * @summary Get CSRF request data
 */

export const GetBffCsrfResponse = zod.object({
  headerName: zod.literal("X-CSRF-TOKEN"),
  parameterName: zod.literal("_csrf"),
  token: zod.string().min(1),
});

/**
 * Top-level browser navigation endpoint. Do not invoke with fetch.
 * Requires an authenticated ERP BFF session and redirects only to the fixed,
 * server-configured Keycloak Account Console URI. It accepts no query parameters.
 * A 503 response is reserved for a future dynamic configuration failure; invalid
 * static configuration fails gateway startup instead.
 * @summary Open Keycloak Account Console
 */
export const LaunchBffAccountConsoleResponse = zod.void();

/**
 * Top-level browser navigation endpoint. Do not invoke with fetch.
 * The gateway validates returnTo before login and keeps it only in a bounded,
 * expiring, one-time server-side OAuth-state transaction.
 * @summary Begin OIDC login
 */
export const beginBffLoginQueryReturnToMax = 2048;

export const BeginBffLoginQueryParams = zod.object({
  returnTo: zod.coerce
    .string()
    .max(beginBffLoginQueryReturnToMax)
    .optional()
    .describe("Validated root-relative application location. Omit for `\/`."),
});

export const BeginBffLoginResponse = zod.void();

/**
 * Submit as a top-level application/x-www-form-urlencoded browser form.
 * The `_csrf` form parameter is canonical; unsafe non-navigation clients may use
 * the CSRF header supplied by `/bff/csrf` instead.
 * @summary Log out browser session
 */

export const SubmitBffLogoutBody = zod.object({
  _csrf: zod.string().min(1),
});

export const SubmitBffLogoutResponse = zod.void();

/**
 * Public browser redirect target after OpenID Provider logout. Always redirects to
 * fixed SPA-owned `/signed-out` route. It accepts no redirect destination.
 * @summary Complete browser logout
 */
export const CompleteBffLogoutResponse = zod.void();
